import { logUsage } from 'owa-analytics';
import { DatapointVariant } from 'owa-analytics-types';
import {
    createTimeStreamProject,
    getLoadingProjectsFailure,
    getDefaultProjectLoadState,
    setDefaultProjectLoadState,
    DefaultProjectLoadState,
} from 'owa-timestream-store';
import type { NewOutlookSpace, NewOutlookSpaceAsset } from 'owa-timestream-types';
import didLoadingCalendarBoardProjectFail from '../selectors/didLoadingCalendarBoardProjectFail';
import loc from 'owa-localize';
import { calendarBoardDefaultProjectName } from './CalendarBoardProject.locstring.json';
import { OutlookCalendarAppName } from '../constants';

export async function createDefaultBoardProject(
    assets: NewOutlookSpaceAsset[],
    outlookSpace?: NewOutlookSpace
) {
    setDefaultProjectLoadState(DefaultProjectLoadState.Creating);
    const project: NewOutlookSpace = outlookSpace
        ? {
              ...outlookSpace,
              assets,
          }
        : {
              name: loc(calendarBoardDefaultProjectName),
              appName: OutlookCalendarAppName,
              assets,
          };

    await createTimeStreamProject('' /* targetMailbox */, project);
}

export function logDefaultCalendarBoardLoadState() {
    const loadState = getDefaultProjectLoadState();
    const errorMessage = didLoadingCalendarBoardProjectFail() ? getLoadingProjectsFailure() : '';

    logUsage(
        'DefaultProjectLoadState',
        {
            loadState_1: loadState,
            loadFailureError_2: errorMessage,
        },
        {
            variant: DatapointVariant.WarmOnly,
        }
    );
}
